import { CSSProperties } from 'react';

export const containerStyle: CSSProperties = {
  paddingLeft: '16px',
  paddingRight: '16px',
  paddingTop: '12px',
  display: 'flex',
  gap: '10px'
};

export const stepStyle: CSSProperties = {
  flex: 1,
  height: '4px',
  borderRadius: '2px',
  backgroundColor: 'rgba(0, 0, 0, 0.08)'
};

export const activeStepStyle: CSSProperties = {
  ...stepStyle,
  backgroundColor: '#1A1A1A'
};
